/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var spine_base_field_filter_pb = require('../../../spine/base/field_filter_pb.js');
goog.exportSymbol('proto.spine.server.event.EventFilter', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.event.EventFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.server.event.EventFilter.repeatedFields_, null);
};
goog.inherits(proto.spine.server.event.EventFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.event.EventFilter.displayName = 'proto.spine.server.event.EventFilter';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.server.event.EventFilter.repeatedFields_ = [2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.event.EventFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.event.EventFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.event.EventFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.event.EventFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    aggregateIdList: jspb.Message.toObjectList(msg.getAggregateIdList(),
    google_protobuf_any_pb.Any.toObject, includeInstance),
    eventFieldFilterList: jspb.Message.toObjectList(msg.getEventFieldFilterList(),
    spine_base_field_filter_pb.FieldFilter.toObject, includeInstance),
    contextFieldFilterList: jspb.Message.toObjectList(msg.getContextFieldFilterList(),
    spine_base_field_filter_pb.FieldFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.event.EventFilter}
 */
proto.spine.server.event.EventFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.event.EventFilter;
  return proto.spine.server.event.EventFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.event.EventFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.event.EventFilter}
 */
proto.spine.server.event.EventFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.addAggregateId(value);
      break;
    case 3:
      var value = new spine_base_field_filter_pb.FieldFilter;
      reader.readMessage(value,spine_base_field_filter_pb.FieldFilter.deserializeBinaryFromReader);
      msg.addEventFieldFilter(value);
      break;
    case 4:
      var value = new spine_base_field_filter_pb.FieldFilter;
      reader.readMessage(value,spine_base_field_filter_pb.FieldFilter.deserializeBinaryFromReader);
      msg.addContextFieldFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.event.EventFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.event.EventFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.event.EventFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.event.EventFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAggregateIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getEventFieldFilterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      spine_base_field_filter_pb.FieldFilter.serializeBinaryToWriter
    );
  }
  f = message.getContextFieldFilterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      spine_base_field_filter_pb.FieldFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string event_type = 1;
 * @return {string}
 */
proto.spine.server.event.EventFilter.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.server.event.EventFilter.prototype.setEventType = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated google.protobuf.Any aggregate_id = 2;
 * @return {!Array<!proto.google.protobuf.Any>}
 */
proto.spine.server.event.EventFilter.prototype.getAggregateIdList = function() {
  return /** @type{!Array<!proto.google.protobuf.Any>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {!Array<!proto.google.protobuf.Any>} value */
proto.spine.server.event.EventFilter.prototype.setAggregateIdList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.google.protobuf.Any=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Any}
 */
proto.spine.server.event.EventFilter.prototype.addAggregateId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.Any, opt_index);
};


proto.spine.server.event.EventFilter.prototype.clearAggregateIdList = function() {
  this.setAggregateIdList([]);
};


/**
 * repeated spine.base.FieldFilter event_field_filter = 3;
 * @return {!Array<!proto.spine.base.FieldFilter>}
 */
proto.spine.server.event.EventFilter.prototype.getEventFieldFilterList = function() {
  return /** @type{!Array<!proto.spine.base.FieldFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_base_field_filter_pb.FieldFilter, 3));
};


/** @param {!Array<!proto.spine.base.FieldFilter>} value */
proto.spine.server.event.EventFilter.prototype.setEventFieldFilterList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.spine.base.FieldFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.base.FieldFilter}
 */
proto.spine.server.event.EventFilter.prototype.addEventFieldFilter = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.spine.base.FieldFilter, opt_index);
};


proto.spine.server.event.EventFilter.prototype.clearEventFieldFilterList = function() {
  this.setEventFieldFilterList([]);
};


/**
 * repeated spine.base.FieldFilter context_field_filter = 4;
 * @return {!Array<!proto.spine.base.FieldFilter>}
 */
proto.spine.server.event.EventFilter.prototype.getContextFieldFilterList = function() {
  return /** @type{!Array<!proto.spine.base.FieldFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_base_field_filter_pb.FieldFilter, 4));
};


/** @param {!Array<!proto.spine.base.FieldFilter>} value */
proto.spine.server.event.EventFilter.prototype.setContextFieldFilterList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.spine.base.FieldFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.base.FieldFilter}
 */
proto.spine.server.event.EventFilter.prototype.addContextFieldFilter = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.spine.base.FieldFilter, opt_index);
};


proto.spine.server.event.EventFilter.prototype.clearContextFieldFilterList = function() {
  this.setContextFieldFilterList([]);
};


goog.object.extend(exports, proto.spine.server.event);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../known_type_parsers.js');

proto.spine.server.event.EventFilter.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.event.EventFilter.fromObject(jsObject);
};

proto.spine.server.event.EventFilter.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.event.EventFilter();
  
  if (obj.eventType !== undefined) {
    if (obj.eventType !== null) {
      let value = obj.eventType;
      msg.setEventType(value);
    }
  }
  
  if (obj.aggregateId !== undefined && obj.aggregateId !== null) {
    obj.aggregateId.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addAggregateId(null);
        } else {
          let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
          let value = parser.parse(listItem);
          msg.addAggregateId(value);
        }
      }
    );
  }
  
  if (obj.eventFieldFilter !== undefined && obj.eventFieldFilter !== null) {
    obj.eventFieldFilter.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addEventFieldFilter(null);
        } else {
          let value = proto.spine.base.FieldFilter.fromObject(listItem);
          msg.addEventFieldFilter(value);
        }
      }
    );
  }
  
  if (obj.contextFieldFilter !== undefined && obj.contextFieldFilter !== null) {
    obj.contextFieldFilter.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addContextFieldFilter(null);
        } else {
          let value = proto.spine.base.FieldFilter.fromObject(listItem);
          msg.addContextFieldFilter(value);
        }
      }
    );
  }
  return msg;
};
